/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Button from '../../components/Button';
import DatePicker from '../../components/DatePicker';

import Input from '../../components/Input';
import PageWrapper from '../../components/PageWrapper';
import Select from '../../components/Select';
import Title from '../../components/Title';
import AddField from '../../utils/tableUtils';

import {
  Container,
  IncludeDependentsContainer,
  SerchDataToTableContainer,
} from './styles';
import { InclusionOfBeneficiariesTable } from './InclusionOfBeneficiariesTable';
import { useConsultInclusionOfBeneficiariesController } from './controller';
import DepentendInclude from '../Beneficiaries/DepentendInclude';

const ConsultInclusionOfBeneficiaries: React.FC = () => {
  const {
    statusOptions,
    dateUntilSelectOptions,
    dataTable,
    templateRowExpanded,
    setRowExpanded,
    rowExpanded,
    setSelectedBeneficiary,
    handleSearchDate,
    setSelectedFromDate,
    setSelectedToDate,
    selectedFromDate,
    selectedToDate,
    statusRef,
    colors,
    step,
    setStep,
    beneficiary,
    setBeneficiary,
  } = useConsultInclusionOfBeneficiariesController();
  const defaultColor = colors.palet.institutional3;

  return (
    <>
      {step === 1 && (
        <PageWrapper
          gridTemplateColumns="1fr 8fr 1fr"
          gridTemplateRows="auto 1fr"
        >
          <Container>
            <Title themeColor={colors.palet.institutional}>
              Consultar Inclusão de beneficiários
            </Title>
            <SerchDataToTableContainer formLook onSubmit={handleSearchDate}>
              <Select
                widthContainerDesktop="50%"
                options={statusOptions}
                className="notiflix-option-code"
                title="Status:"
                name="filters"
                formLook
                ref={statusRef}
              />
              <Select
                widthContainerDesktop="50%"
                inputMode
                options={dateUntilSelectOptions}
                // ref={dateOptionRef}
                className="notiflix-option-code"
                title="Modelo do Lote:"
                name="filters"
                formLook
              />

              <DatePicker
                name="from"
                onChange={(date: Date) =>
                  setSelectedFromDate({ value: date, error: '' })
                }
                selected={selectedFromDate.value}
                error={selectedFromDate.error}
                icon
                formLook
                title="Período de:"
                widthContainerDesktop="20%"
              />

              <DatePicker
                name="to"
                onChange={(date: Date) => {
                  setSelectedToDate({ value: date, error: '' });
                }}
                selected={selectedToDate.value}
                error={selectedToDate.error}
                icon
                formLook
                title="Período até:"
                widthContainerDesktop="20%"
              />

              <Input
                name="batch"
                title="Lote"
                formLook
                widthContainerDesktop="20%"
              />

              <Input
                name="beneficiaryName"
                title="Beneficiário"
                placeholder="Nome do Beneficiário"
                formLook
                widthContainerDesktop="50%"
              />
              <Input
                name="requestId"
                title="Solicitação"
                placeholder="ID da Solicitação"
                type="number"
                formLook
                widthContainerDesktop="50%"
              />

              <Button grayButton formLook type="submit">
                Buscar
              </Button>
            </SerchDataToTableContainer>

            <InclusionOfBeneficiariesTable
              dataTable={dataTable}
              templateRowExpanded={templateRowExpanded}
              setRowExpanded={setRowExpanded}
              rowExpanded={rowExpanded}
              setSelectedBeneficiary={setSelectedBeneficiary}
              AddField={AddField}
              setBeneficiary={setBeneficiary}
            />
          </Container>
        </PageWrapper>
      )}

      {step === 2 && (
        <PageWrapper
          gridTemplateColumns="1fr 8fr 1fr"
          gridTemplateRows="auto 1fr"
        >
          <IncludeDependentsContainer>
            <Title themeColor={defaultColor}>Incluir Dependente</Title>

            <DepentendInclude
              defaultColor={defaultColor}
              callbackSetStep={setStep}
              rowsSelecteds={beneficiary}
              showTitle
            />
          </IncludeDependentsContainer>
        </PageWrapper>
      )}
    </>
  );
};

export default ConsultInclusionOfBeneficiaries;
